import { render, staticRenderFns } from "./AiImage.vue?vue&type=template&id=51ed5b40&scoped=true&"
import script from "./AiImage.vue?vue&type=script&lang=js&"
export * from "./AiImage.vue?vue&type=script&lang=js&"
import style0 from "./AiImage.vue?vue&type=style&index=0&id=51ed5b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed5b40",
  null
  
)

export default component.exports